import { GET_VENDOR_TASK_LIST,UPDATE_VENDOR_TASK_DETAIL } from "../../utils/constants";


const initialState = {
    vendorPlanList: [],
    vendorPlanDetails: []
};

function getVendorTaskListReducer(state = initialState, action) {
    const { type, payload } = action

    switch (type) {
        case GET_VENDOR_TASK_LIST:
            return {
                ...state,
                vendorTaskList: payload.data?.vendorTaskList || []
            };

        case UPDATE_VENDOR_TASK_DETAIL:
            return {
                ...state,
                vendorTaskDetails: payload.data?.vendorTaskDetails || []
            };

        default:
            return state;
    }
};

export default getVendorTaskListReducer